import { render } from "./checklist-item.vue?vue&type=template&id=c96d633a&lang=true"
import script from "./checklist-item.vue?vue&type=script&lang=js"
export * from "./checklist-item.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__